import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Star } from 'lucide-react';

const Hero = ({ onShopNow }) => {
  return (
    <section className="relative bg-gradient-to-br from-gray-900 via-black to-green-900 text-white overflow-hidden min-h-screen flex items-center">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          backgroundRepeat: 'repeat'
        }}></div>
      </div>

      <div className="relative container mx-auto px-4 py-16 lg:py-24">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="text-center lg:text-left">
            <div className="mb-8">
              <div className="flex items-center justify-center lg:justify-start gap-2 mb-6">
                <div className="flex text-green-400">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} size={20} fill="currentColor" />
                  ))}
                </div>
                <span className="text-gray-300 text-sm">Premium Quality Guaranteed</span>
              </div>
              
              <h1 className="text-5xl lg:text-7xl font-bold mb-6 leading-tight">
                <span className="text-green-400">Big Dog</span>
                <span className="block text-white">Kush</span>
              </h1>
              
              <p className="text-xl lg:text-2xl text-gray-300 mb-6 leading-relaxed">
                Dallas's Premier Cannabis Experience
              </p>
              
              <p className="text-gray-400 mb-8 text-lg max-w-md mx-auto lg:mx-0">
                Top-shelf exotic strains, certified quality, and unmatched service. 
                Experience the difference with Big Dog Kush.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-8">
              <Button 
                onClick={onShopNow}
                size="lg" 
                className="bg-green-600 hover:bg-green-700 text-white font-semibold px-10 py-4 text-lg group transition-all duration-300 rounded-xl"
              >
                Shop Menu
                <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
              </Button>
              
              <Button 
                onClick={() => window.location.href = 'sms:+19455457553?body=' + encodeURIComponent('Hi! I\'d like to place an order from Big Dog Kush. Can you help me with your menu?')}
                size="lg"
                className="border-2 border-green-400 text-green-400 hover:bg-green-400 hover:text-gray-900 font-semibold px-10 py-4 text-lg rounded-xl"
              >
                Text to Order
              </Button>
            </div>

            {/* Text Order Highlight */}
            <div className="bg-green-900/20 backdrop-blur-sm rounded-2xl p-6 mb-8 border border-green-600/30">
              <div className="flex items-center justify-center gap-4">
                <div className="text-green-400 text-2xl">📱</div>
                <div className="text-center">
                  <p className="text-green-400 font-bold text-xl mb-1">Text Orders Available</p>
                  <p className="text-white text-lg">Text (945) 545-7553 to Place Orders</p>
                  <p className="text-gray-400 text-sm">Fast • Easy • Secure</p>
                </div>
              </div>
            </div>

            {/* Premium Features */}
            <div className="flex flex-wrap justify-center lg:justify-start gap-8 text-sm">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-green-400 rounded-full"></div>
                <span className="text-gray-300 font-medium">Lab Tested</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-green-400 rounded-full"></div>
                <span className="text-gray-300 font-medium">Sealed Fresh</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-green-400 rounded-full"></div>
                <span className="text-gray-300 font-medium">Premium Quality</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-green-400 rounded-full"></div>
                <span className="text-gray-300 font-medium">Dallas Delivery</span>
              </div>
            </div>
          </div>

          {/* Brand Showcase */}
          <div className="relative">
            <div className="relative z-10">
              <div className="bg-white/5 backdrop-blur-sm rounded-3xl p-8 border border-white/10">
                <img 
                  src="https://customer-assets.emergentagent.com/job_f6290634-86b4-4bd7-80d7-4011d06242d9/artifacts/mvt79ma9_29A81CA4-6157-450E-BDCF-09CA0369D517.png"
                  alt="Big Dog Kush Logo" 
                  className="h-32 mx-auto mb-6 filter drop-shadow-2xl"
                />
                <div className="text-center">
                  <h3 className="text-2xl font-bold text-white mb-3">Authentic Quality</h3>
                  <p className="text-gray-300 mb-6">Certified by the streets, approved by the people</p>
                  
                  <div className="grid grid-cols-2 gap-4 text-center">
                    <div className="bg-green-600/20 rounded-xl p-4">
                      <div className="text-2xl font-bold text-green-400">11+</div>
                      <div className="text-xs text-gray-400">Premium Strains</div>
                    </div>
                    <div className="bg-green-600/20 rounded-xl p-4">
                      <div className="text-2xl font-bold text-green-400">24/7</div>
                      <div className="text-xs text-gray-400">Text Orders</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Floating Elements */}
            <div className="absolute top-4 right-4 bg-green-600 text-white px-4 py-2 rounded-full text-sm font-bold transform rotate-12 shadow-lg">
              New Drops!
            </div>
            
            <div className="absolute bottom-4 left-4 bg-yellow-500 text-gray-900 px-4 py-2 rounded-full text-sm font-bold transform -rotate-6 shadow-lg">
              Premium Only
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;